import { h, Host } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import { send, productSelectorVirtualPageEvent, isAnalyticsEnabled, deepMerge, ConfiguratorHandler, ICONS_BY_TYPE } from '@pes-ui/utils';
export class ProductSelector {
  constructor() {
    var _a;
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.renderActionBlock = () => (h("pes-action-block", { heading: this.actionBlock.label, text: this.actionBlock.linkText, icon: ICONS_BY_TYPE[this.actionBlock.type], onClick: this.handleClick }));
    this.handleClick = () => {
      this.opened = true;
      if (isAnalyticsEnabled()) {
        send(productSelectorVirtualPageEvent);
      }
    };
    this.handleLoaderClick = () => {
      this.opened = false;
    };
    this.actionBlock = undefined;
    this.selectorConfig = undefined;
    this.opened = false;
    this.selector = undefined;
  }
  openProductSelector() {
    if (!this.opened || !this.selectorConfig || !this.selector) {
      return;
    }
    if (this.selectorConfig.type === 'sc') {
      const host = document.createElement('pdp-sc-selector-modal');
      const frame = document.createElement('div');
      frame.id = 'widgetFrame';
      host.headerLabel = this.selectorConfig.scLabel || 'Select your product';
      host.appendChild(frame);
      host.open = true;
      host.addEventListener('didClose', () => {
        document.body.removeChild(host);
        this.opened = false;
      });
      document.body.appendChild(host);
    }
    this.selector.open(this.getSelectorConfig());
  }
  getSelectorConfig() {
    var _a, _b, _c;
    if (!this.selectorConfig) {
      return {};
    }
    let baseConfig = deepMerge(this.selectorConfig, {
      scOptions: !isEmpty((_a = this.actionBlock.selectorConfig) === null || _a === void 0 ? void 0 : _a.scOptions)
        ? this.actionBlock.selectorConfig.scOptions
        : {},
    });
    if (this.isUnifiedCheckoutEnabled) {
      baseConfig = deepMerge(baseConfig, {
        scOptions: {
          buttons: {
            saveConfiguration: {
              title: (_b = this.actionBlock) === null || _b === void 0 ? void 0 : _b.addToMyCart,
              isVisible: true,
            },
            addToListConfiguration: {
              title: (_c = this.actionBlock) === null || _c === void 0 ? void 0 : _c.addToMyList,
              isVisible: true,
            },
          },
        },
      });
    }
    return baseConfig;
  }
  render() {
    return (h(Host, null, h("se-loading", { loading: this.opened && !this.selectorConfig, onClick: this.handleLoaderClick, fullPage: true, overlay: true }), this.selectorConfig ? (h("pes-product-selector", { config: this.getSelectorConfig(), renderFunction: (selector) => {
        this.selector = selector;
        return this.renderActionBlock();
      } })) : (this.renderActionBlock())));
  }
  static get is() { return "pes-action-block-product-selector"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "actionBlock": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ActionBlock",
          "resolved": "{ label: string; linkText: string; type: string; addToMyCart?: string; addToMyList?: string; link?: string; selectorConfig?: ScProductSelectorConfig; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "selectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TScProductSelectorConfig",
          "resolved": "{ type: \"sc\"; scConfiguratorUrlJS: string; scConfiguratorUrlCSS: string; scLanguage: string; scCountry: string; scToken: string; scProject: string; scDataset: string; scOptions: Record<string, unknown>; scFunctionalIds: string; scLabel: string; }",
          "references": {
            "TScProductSelectorConfig": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "opened": {},
      "selector": {}
    };
  }
  static get watchers() {
    return [{
        "propName": "opened",
        "methodName": "openProductSelector"
      }, {
        "propName": "selectorConfig",
        "methodName": "openProductSelector"
      }, {
        "propName": "selector",
        "methodName": "openProductSelector"
      }];
  }
}
